import React, { createContext, useContext, useEffect, useState } from "react";

const ConsentContext = createContext(null);
const STORAGE_KEY = "abc_cookie_consent_v1";

export const ConsentProvider = ({ children }) => {
  const [consent, setConsent] = useState(null); // null = undecided
  const [managerOpen, setManagerOpen] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setConsent(JSON.parse(raw));
    } catch (e) {
      /* ignore */
    }
  }, []);

  const persist = (value) => {
    const payload = { ...value, decidedAt: new Date().toISOString() };
    setConsent(payload);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {
      /* ignore */
    }
  };

  const acceptAll = () => persist({ necessary: true, preferences: true, analytics: true });
  const rejectNonEssential = () => persist({ necessary: true, preferences: false, analytics: false });
  const savePreferences = (prefs) =>
    persist({ necessary: true, preferences: !!prefs.preferences, analytics: !!prefs.analytics });

  return (
    <ConsentContext.Provider
      value={{
        consent,
        decided: consent !== null,
        acceptAll,
        rejectNonEssential,
        savePreferences,
        managerOpen,
        setManagerOpen,
      }}
    >
      {children}
    </ConsentContext.Provider>
  );
};

export const useConsent = () => {
  const ctx = useContext(ConsentContext);
  if (!ctx) throw new Error("useConsent must be used within ConsentProvider");
  return ctx;
};
